import React from 'react';
export const Footer = () => {
  return <footer className="bg-sage-900 text-sage-200/60 py-8 text-center text-sm" data-id="element-43">
      <div className="max-w-6xl mx-auto px-6" data-id="element-44">
        <p data-id="element-45">© 2026 Deshinchate. Todos los derechos reservados.</p>
        <p className="mt-2 text-xs opacity-70" data-id="element-46">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
};